import { render, staticRenderFns } from "./ProjetEdit.vue?vue&type=template&id=b6176b84&"
import script from "./ProjetEdit.vue?vue&type=script&lang=js&"
export * from "./ProjetEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports